import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

const defaultUserProfile = {
  familyType: null,
  familyStatus: null,
  familyValue: null,
  brother: null,
  marriedBrother: null,
  sister: null,
  marriedSister: null,
  fatherEducation: null,
  fatherService: null,
  motherEducation: null,
  motherService: null,
  houseType: null,
  familyIncome: null,
  familyMembers: null
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.user.profile;
  //get all static data
  const { data } = state;
  //if any of the static data is empty return the default value
  if (
    isEmpty(data.familyType) ||
    isEmpty(data.familyStatus) ||
    isEmpty(data.familyValue) ||
    isEmpty(data.education) ||
    isEmpty(data.houseType) ||
    isEmpty(data.income) ||
    isEmpty(data.employedIn)
  ) {
    return defaultUserProfile;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return defaultUserProfile;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(userProfile, (value, key) => {
      if (key === "familyType") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "familyStatus") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "familyValue") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (
        key === "brother" ||
        key === "sister" ||
        key === "marriedBrother" ||
        key === "marriedSister"
      ) {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (value === 0) {
            object[key] = { label: "None", value };
          } else {
            object[key] = { label: value, value };
          }
        }
      } else if (key === "fatherEducation" || key === "motherEducation") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data.education[value]) {
            object[key] = {
              label: data.education[value].label,
              value: data.education[value].value,
              description: data.education[value].description
            };
          }
        }
      } else if (key === "fatherService" || key === "motherService") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (value === "houseWife") {
            object[key] = {
              label: "House Wife",
              value: "houseWife",
              description: "House Wife"
            };
          } else {
            if (data.employedIn[value]) {
              object[key] = {
                label: data.employedIn[value].label,
                value: data.employedIn[value].value,
                description: data.employedIn[value].description
              };
            }
          }
        }
      } else if (key === "familyIncome") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data.income[value]) {
            object[key] = {
              label: data.income[value].label,
              value: data.income[value].value,
              description: data.income[value].description
            };
          }
        }
      } else if (key === "houseType") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (data[key][value]) {
            object[key] = {
              label: data[key][value].label,
              value: data[key][value].value,
              description: data[key][value].description
            };
          }
        }
      } else if (key === "familyMembers") {
        if (isNull(value)) {
          object[key] = null;
        } else {
          if (value === 0) {
            object[key] = { label: "None", value };
          } else {
            object[key] = { label: value, value };
          }
        }
      } else {
        //do nothing
      }
    });
    return object;
  } catch (error) {
    return defaultUserProfile;
  }
};
//VERIFY IF THE JWT IS SET
const getMyUserFamilyProfile = createSelector(
  getData,
  userProfile => userProfile
);
export default getMyUserFamilyProfile;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyUserFamilyProfile.js